import styled from 'styled-components';

import { EmailAddressInput } from '@dreryk/react-components';

export const StyledAppointmentRequestsEmailField = styled(EmailAddressInput)`
   width: 300px;
`;
